import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAcPowerIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 25,
	viewBox: "0 0 18 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.2431 14.7488V14.0849H2.55037L8.57148 3.36963V10.1015C8.57148 10.2775 8.642 10.4468 8.76961 10.5696C8.89721 10.6924 9.06848 10.7654 9.2431 10.7654H15.9358L9.91473 21.4808V14.7488C9.91473 14.5729 9.8442 14.4036 9.71659 14.2808C9.59234 14.158 9.41772 14.0849 9.2431 14.0849V14.7488H8.57148V24.0434C8.57148 24.3455 8.77968 24.6111 9.0752 24.6874C9.37071 24.7638 9.68302 24.631 9.83077 24.3688L17.6653 10.4269C17.7794 10.2211 17.7761 9.96876 17.6585 9.76627C17.5377 9.56378 17.316 9.43764 17.081 9.43764H9.91808V0.806952C9.91808 0.504878 9.70988 0.239337 9.41436 0.162989C9.11885 0.0866405 8.80655 0.219407 8.65879 0.481648L0.824296 14.4235C0.71012 14.6293 0.71348 14.8816 0.831014 15.0841C0.948548 15.2866 1.17354 15.4127 1.40861 15.4127H9.2431V14.7488H8.57148H9.2431Z",
		fill: "#2C3F81"
	})
});
export default SvgAcPowerIcon;
